<template>
  <div>
    <h3 class="">Bem-vindo(a) {{ usuarioLogado.nome }} ao ModOsWEB!</h3>

    <div class="dashboard-shortcuts">

      <router-link v-for="(menu, index) in menusUsuario" :key="index"
        :to="menu.url"
        class="d"
        aria-label="Shortcut clicável"
      >
        <i class=""></i>
        <p class="">{{menu.titulo}}</p>
      </router-link>
     
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "DashboardPage",
  data () {
    return {
      data: ''
    }
  },
  computed: {
      ...mapGetters('login', ['usuarioLogado']),
      menusUsuario(){
        return this.usuarioLogado.menus;
      }
  },
};
</script>

<style lang="scss" scoped>
.dashboard-shortcuts {
  display: flex;
  align-content: space-around;
  justify-content: left;
  flex-wrap: wrap;
  flex-direction: row;
  // background: red;

  a {
    display: flex;
    align-items: flex-end;
    margin: 5px;
    justify-content: left;
    border: solid 1px #ddd;
    width: 160px;
    height: 160px;
    padding: 25px 25px 0 25px;
    border-radius: 10px;
    text-decoration: none;
    transition: all 0.5s;

    &:hover {
      border-color: red;
    }
  }
}
</style>